import { Injectable } from '@angular/core';

import { BaseStorage } from '../../core/abstractions/base.storage';
import { AuthResponseModel } from '../../models/core/auth-response.model';
import { StorageTypeEnum } from '../../models/enums/storage-type.enum';
import { PermissionModel } from '../../models/permission.model';
import { OptionalType } from '../../models/types/optional.type';

@Injectable({
    providedIn: 'root'
})
export class SecurityStorage extends BaseStorage {
    private userInfoKey = 'userInfo';
    private permissionsKey = 'permissions';

    constructor() {
        super('security', StorageTypeEnum.Session);
    }

    saveUserInfo(userInfo: AuthResponseModel): void {
        this.save(userInfo, this.userInfoKey);
    }

    getUserInfo(): OptionalType<AuthResponseModel> {
        return this.get<AuthResponseModel>(this.userInfoKey);
    }

    savePermissions(permissions: PermissionModel[]): void {
        this.save(permissions, this.permissionsKey);
    }

    getPermissions(): PermissionModel[] {
        return this.get<PermissionModel[]>(this.permissionsKey) ?? [];
    }

    eraseSecurityData(): void {
        this.remove(this.userInfoKey, this.permissionsKey);
    }
}
